import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";

import { Col, Container, Row, Card, CardBody, Label } from "reactstrap";

// Redux
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";

import Loader from "../../components/Common/Loader";

//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";

//Action

import { casosDetallesFilter } from "../../store/actions";

import CasosDetallesLista from "./components/CasosDetallesLista";

const CasosDetalles = (props) => {
  const dispatch = useDispatch();
  const param = useParams();
  const str = param.id;
  const casosId = Number(str);
  const user = JSON.parse(localStorage.getItem("user"));
  const groups = String(user.groups);

  const [checked, setchecked] = useState(false);

  console.log(groups);

  useEffect(() => {
    dispatch(casosDetallesFilter(`get_gestiones_caso/?caso=${casosId}`));
  }, [dispatch, casosId]);

  useEffect(() => {
    // Obtener el valor almacenado en el Local Storage al cargar el componente
    const storedChecked = localStorage.getItem("checked");
    if (storedChecked) {
      setchecked(JSON.parse(storedChecked));
    }
  }, []);

  useEffect(() => {
    // Guardar el valor en el Local Storage cada vez que cambie
    localStorage.setItem("checked", JSON.stringify(checked));
  }, [checked]);

  const changeLista = (e) => {
    setchecked(e.target.checked);
  };

  const gestionesCaso = useSelector(
    (state) => state.CasosDetalles.casosDetalles
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title> Gestiones del Caso</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumb breadcrumbItem={"Casos"} />
          {props.loading ? (
            <Loader />
          ) : (
            <>
              <Row>
                <Col md={7}>
                  <Link
                    className="btn btn-primary waves-effect waves-light"
                    to={`/casos/${casosId}/edit_caso`}
                  >
                    Volver al Caso{" "}
                    <span className="bx bx-user-plus fa-lg align-middle"></span>
                  </Link>
                </Col>
              </Row>
              <div className="form-check form-switch mb-3">
                <input
                  className="form-check-input mt-3 mx-1"
                  type="checkbox"
                  id="flexSwitchCheckChecked"
                  onChange={changeLista}
                  checked={checked}
                />
                <Label
                  className="form-check-label mt-3 "
                  for="flexSwitchCheckChecked"
                >
                  Ver en Lista
                </Label>
              </div>
              {!checked ? (
                <>
                  <Row className="justify-content-center">
                    <Col xl={10}>
                      <div className="timeline">
                        <div className="timeline-item timeline-left">
                          <div className="timeline-block">
                            <div className="time-show-btn mt-0">
                              <Link to="#" className="btn btn-success w-lg">
                                Caso {casosId}
                              </Link>
                            </div>
                          </div>
                        </div>
                        {Array.isArray(gestionesCaso)
                          ? gestionesCaso.map((item, index) => {
                              const timelineItemClass =
                                index % 2 === 0
                                  ? "timeline-item"
                                  : "timeline-item timeline-left";

                              console.log(item.fecha_asignar);
                              return (
                                <div
                                  className={timelineItemClass}
                                  key={item.id}
                                >
                                  <div className="timeline-block">
                                    <Card className="timeline-box">
                                      <CardBody>
                                        <span className="timeline-icon"></span>

                                        {item.fecha_asignar !== "" ? (
                                          <>
                                            <div className="timeline-date">
                                              <i className="mdi mdi-circle-medium circle-dot"></i>{" "}
                                              {item.fecha_asignar.substring(
                                                0,
                                                10
                                              )}
                                            </div>

                                            <div className="text-muted">
                                              <p className="mb-0">
                                                {item.fecha_asignar.substring(
                                                  10
                                                )}
                                              </p>
                                            </div>
                                            <h5 className="mt-3 foont-size-15">
                                              {" "}
                                              Usuario
                                            </h5>
                                            <div className="text-muted">
                                              <p className="mb-0">
                                                {item.usuario}
                                              </p>
                                            </div>
                                            <h5 className="mt-3 foont-size-15">
                                              {" "}
                                              Estado
                                            </h5>
                                            <div className="text-muted">
                                              <p className="mb-0">Asignar</p>
                                            </div>
                                            <h5 className="mt-3 foont-size-15">
                                              {" "}
                                              Tecnico Asignado
                                            </h5>
                                            <div className="text-muted">
                                              <p className="mb-0">
                                                {item.tecnico_asignado}
                                              </p>
                                            </div>
                                            <h5 className="mt-3 foont-size-15">
                                              {" "}
                                              Observacion
                                            </h5>
                                            <div className="text-muted">
                                              <p className="mb-0">
                                                {item.observaciones}
                                              </p>
                                            </div>
                                          </>
                                        ) : item.fecha_aceptar !== "" ? (
                                          <>
                                            <div className="timeline-date">
                                              <i className="mdi mdi-circle-medium circle-dot"></i>{" "}
                                              {item.fecha_aceptar.substring(
                                                0,
                                                10
                                              )}
                                            </div>

                                            <div className="text-muted">
                                              <p className="mb-0">
                                                {item.fecha_aceptar.substring(
                                                  10
                                                )}
                                              </p>
                                            </div>
                                            <h5 className="mt-3 foont-size-15">
                                              {" "}
                                              Usuario
                                            </h5>
                                            <div className="text-muted">
                                              <p className="mb-0">
                                                {item.usuario}
                                              </p>
                                            </div>
                                            <h5 className="mt-3 foont-size-15">
                                              {" "}
                                              Estado
                                            </h5>
                                            <div className="text-muted">
                                              <p className="mb-0">Aceptar</p>
                                            </div>
                                          </>
                                        ) : item.fecha_iniciar !== "" ? (
                                          <>
                                            <div className="timeline-date">
                                              <i className="mdi mdi-circle-medium circle-dot"></i>{" "}
                                              {item.fecha_iniciar.substring(
                                                0,
                                                10
                                              )}
                                            </div>

                                            <div className="text-muted">
                                              <p className="mb-0">
                                                {item.fecha_iniciar.substring(
                                                  10
                                                )}
                                              </p>
                                            </div>
                                            <h5 className="mt-3 foont-size-15">
                                              {" "}
                                              Usuario
                                            </h5>
                                            <div className="text-muted">
                                              <p className="mb-0">
                                                {item.usuario}
                                              </p>
                                            </div>
                                            <h5 className="mt-3 foont-size-15">
                                              {" "}
                                              Estado
                                            </h5>
                                            <div className="text-muted">
                                              <p className="mb-0">Iniciar</p>
                                            </div>
                                          </>
                                        ) : item.fecha_pausa !== "" ? (
                                          <>
                                            <div className="timeline-date">
                                              <i className="mdi mdi-circle-medium circle-dot"></i>{" "}
                                              {item.fecha_pausa.substring(
                                                0,
                                                10
                                              )}
                                            </div>

                                            <div className="text-muted">
                                              <p className="mb-0">
                                                {item.fecha_pausa.substring(10)}
                                              </p>
                                            </div>
                                            <h5 className="mt-3 foont-size-15">
                                              {" "}
                                              Usuario
                                            </h5>
                                            <div className="text-muted">
                                              <p className="mb-0">
                                                {item.usuario}
                                              </p>
                                            </div>
                                            <h5 className="mt-3 foont-size-15">
                                              {" "}
                                              Estado
                                            </h5>
                                            <div className="text-muted">
                                              <p className="mb-0">Pausar</p>
                                            </div>
                                          </>
                                        ) : item.fecha_reanudar !== "" ? (
                                          <>
                                            <div className="timeline-date">
                                              <i className="mdi mdi-circle-medium circle-dot"></i>{" "}
                                              {item.fecha_reanudar.substring(
                                                0,
                                                10
                                              )}
                                            </div>

                                            <div className="text-muted">
                                              <p className="mb-0">
                                                {item.fecha_reanudar.substring(
                                                  10
                                                )}
                                              </p>
                                            </div>
                                            <h5 className="mt-3 foont-size-15">
                                              {" "}
                                              Usuario
                                            </h5>
                                            <div className="text-muted">
                                              <p className="mb-0">
                                                {item.usuario}
                                              </p>
                                            </div>
                                            <h5 className="mt-3 foont-size-15">
                                              {" "}
                                              Estado
                                            </h5>
                                            <div className="text-muted">
                                              <p className="mb-0">Reanudar</p>
                                            </div>
                                          </>
                                        ) : item.fecha_finalizar !== "" ? (
                                          <>
                                            <div className="timeline-date">
                                              <i className="mdi mdi-circle-medium circle-dot"></i>{" "}
                                              {item.fecha_finalizar.substring(
                                                0,
                                                10
                                              )}
                                            </div>

                                            <div className="text-muted">
                                              <p className="mb-0">
                                                {item.fecha_finalizar.substring(
                                                  10
                                                )}
                                              </p>
                                            </div>
                                            <h5 className="mt-3 foont-size-15">
                                              {" "}
                                              Usuario
                                            </h5>
                                            <div className="text-muted">
                                              <p className="mb-0">
                                                {item.usuario}
                                              </p>
                                            </div>
                                            <h5 className="mt-3 foont-size-15">
                                              {" "}
                                              Estado
                                            </h5>
                                            <div className="text-muted">
                                              <p className="mb-0">Finalizar</p>
                                            </div>
                                          </>
                                        ) : item.fecha_finalizar === "" &&
                                          item.fecha_asignar === "" &&
                                          item.fecha_aceptar === "" &&
                                          item.fecha_iniciar === "" &&
                                          item.fecha_pausa === "" &&
                                          item.fecha_reanudar === "" ? (
                                          <>
                                            <div className="timeline-date">
                                              <i className="mdi mdi-circle-medium circle-dot"></i>{" "}
                                              {item.created_date}
                                            </div>

                                            <div className="text-muted">
                                              <p className="mb-0"></p>
                                            </div>
                                            <h5 className="mt-3 foont-size-15">
                                              {" "}
                                              Usuario
                                            </h5>
                                            <div className="text-muted">
                                              <p className="mb-0">
                                                {item.usuario}
                                              </p>
                                            </div>
                                            <h5 className="mt-3 foont-size-15">
                                              {" "}
                                              Observacion
                                            </h5>
                                            <div className="text-muted">
                                              <p className="mb-0">
                                                {item.observaciones}
                                              </p>
                                            </div>
                                          </>
                                        ) : null}
                                      </CardBody>
                                    </Card>
                                  </div>
                                </div>
                              );
                            })
                          : []}
                      </div>
                    </Col>
                  </Row>
                </>
              ) : (
                <CasosDetallesLista
                  gestionesCaso={gestionesCaso}
                ></CasosDetallesLista>
              )}
            </>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CasosDetalles;
